'use client';

import { Search, SlidersHorizontal } from 'lucide-react';
import { useState } from 'react';

export interface FilterState {
  search: string;
  country: string;
  sortBy: 'date' | 'artist' | 'availability';
}

interface FilterControlsProps {
  onFilterChange: (filters: FilterState) => void;
}

export function FilterControls({ onFilterChange }: FilterControlsProps) {
  const [filters, setFilters] = useState<FilterState>({
    search: '',
    country: '',
    sortBy: 'date',
  });

  const updateFilters = (updates: Partial<FilterState>) => {
    const newFilters = { ...filters, ...updates };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  return (
    <div className="mb-12 space-y-6">
      {/* Search Bar */}
      <div className="relative">
        <Search className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-[#D4AF37]" />
        <input
          type="text"
          placeholder="Search by artist or event..."
          value={filters.search}
          onChange={(e) => updateFilters({ search: e.target.value })}
          className="w-full rounded-lg border border-[#D4AF37]/20 bg-black/40 py-4 pl-12 pr-4 text-white backdrop-blur-md transition-all duration-300 placeholder:text-gray-500 focus:border-[#D4AF37] focus:outline-none focus:ring-2 focus:ring-[#D4AF37]/30"
        />
      </div>

      {/* Filter Controls */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2 text-[#D4AF37]">
          <SlidersHorizontal className="h-5 w-5" />
          <span className="font-serif text-lg">Filters</span>
        </div>

        <div className="flex flex-wrap gap-4">
          {/* Country Filter */}
          <select
            value={filters.country}
            onChange={(e) => updateFilters({ country: e.target.value })}
            className="rounded-lg border border-[#D4AF37]/20 bg-black/40 px-4 py-2 text-white backdrop-blur-md transition-all duration-300 hover:border-[#D4AF37] focus:border-[#D4AF37] focus:outline-none focus:ring-2 focus:ring-[#D4AF37]/30"
          >
            <option value="">All Countries</option>
            <option value="Bangladesh">Bangladesh</option>
            <option value="India">India</option>
            <option value="Nepal">Nepal</option>
            <option value="Sri Lanka">Sri Lanka</option>
          </select>

          {/* Sort By */}
          <select
            value={filters.sortBy}
            onChange={(e) =>
              updateFilters({ sortBy: e.target.value as FilterState['sortBy'] })
            }
            className="rounded-lg border border-[#D4AF37]/20 bg-black/40 px-4 py-2 text-white backdrop-blur-md transition-all duration-300 hover:border-[#D4AF37] focus:border-[#D4AF37] focus:outline-none focus:ring-2 focus:ring-[#D4AF37]/30"
          >
            <option value="date">Sort by Date</option>
            <option value="artist">Sort by Artist</option>
            <option value="availability">Sort by Availability</option>
          </select>
        </div>
      </div>
    </div>
  );
}
